import { PaymentStatusType, SubscriptionStatus } from '@dtos/Order'
import { IUserOrder, IUserOrderItem } from '@hooks/useUserOrders'

// Só os estados de ESTORNO do item vencem o status da cobrança. `active` fica de fora de
// propósito: no sparkecommerce ele significa "não estornado" e o payment_item nasce assim junto
// com a cobrança (PaymentItems::SyncService roda na criação, com o pix/boleto ainda em aberto),
// então mapeá-lo para "Pago" marcava como pago todo item de pedido ainda não pago.
const ITEM_STATUS_BADGE: Record<string, PaymentStatusType> = {
  refunded: 'refunded',
  refund_processing: 'refund_analyzing',
}

// Exportado para o spec: a regra de badge por item é a única coisa que separa "item ainda não
// pago" de "item pago" na listagem, e testá-la por fora custaria montar a árvore inteira do
// tamagui para as mesmas asserções.
export function badgeStatusFor(
  order: IUserOrder,
  item?: IUserOrderItem,
): PaymentStatusType | SubscriptionStatus {
  const orderStatus = (order.subscriptionStatus || order.paymentStatus) as
    | PaymentStatusType
    | SubscriptionStatus
  // Linha decomposta: o item principal de assinatura mostra o status DA ASSINATURA
  // ("Ativa"/"Cancelada"); bump mostra o status da própria cobrança — cancelar a
  // assinatura não muda o badge de um bump pago (homologação 28/08).
  const isSubscription = item
    ? !item.orderBump && order.isSubscription
    : order.isSubscription

  if (!item || isSubscription) return orderStatus

  // Item sem estorno segue o status da COBRANÇA do pedido (pago, aguardando, vencido), que é o
  // que o aluno precisa ver enquanto o pix/boleto está em aberto.
  return (
    (item.itemStatus && ITEM_STATUS_BADGE[item.itemStatus]) ||
    ((order.paymentStatus || orderStatus) as PaymentStatusType)
  )
}
